import { withStyles } from 'tss-react/mui';
import { SliderWrapper } from './sliderWrapper';

export const ResponsiveSliderWrapper = withStyles(SliderWrapper, (theme) => ({
	root: {

	},
	label: {
		[theme.breakpoints.up('lg')]: {
			fontSize: '18px',
			lineHeight: '28px'
		}
	},
	value: {
		[theme.breakpoints.up('md')]: {
			fontSize: '24px',
			lineHeight: '28px',
			marginBottom: '24px'
		}
	},
	panelMinMax: {
		[theme.breakpoints.up('md')]: {
			marginTop: 24
		},
		[theme.breakpoints.up('lg')]: {
			fontSize: '14px',
			lineHeight: '20px',
			marginTop: 30
		}
	}
}));
